import { TimeField } from "@mui/x-date-pickers/TimeField";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, purpleMui } from "@ryde/theme";

export const TimeFieldWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "time-field-wrapper",
})`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding-block: 3px;
  padding-inline: 7px;
  border: 1px solid ${greyMui._300};
  border-radius: 4px;
  color: ${blueGreyMui._400};
  cursor: pointer;
  svg.circle-x-mark {
    color: ${blueGreyMui.A200};
  }

  &.TimeFieldWrapper-focused,
  &:hover {
    border-color: ${purpleMui._500};
  }
`;

export const TimeFieldLabel = styled.label.attrs<IStyledAttributes>({
  "data-e2e": "time-field-label",
})`
  display: flex;
  align-items: center;
  cursor: inherit;
`;

export const TimeFieldInputStyled = styled(TimeField)<{ $isRtl: boolean }>`
  & .MuiPickersSectionList-root {
    padding: 0px;
    width: 80px;

    ${({ $isRtl }) => {
      return {
        justifyContent: $isRtl ? "end" : "initial",
      };
    }};
  }

  & .MuiPickersOutlinedInput-root {
    padding: 0px;
  }

  & .MuiPickersOutlinedInput-notchedOutline,
  & .Mui-focused .MuiPickersOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiInputBase-adornedEnd {
    padding-inline-start: 0;
  }

  & .MuiInputAdornment-root {
    margin-block-start: 2px;
    margin-inline-end: 7px;
  }
`;
